import React, {Component} from 'react';
import ToasterSingleton from "../../../../singleton/ToasterSingleton";
import SchedaSpecialeTubercolosi from "./SchedeSpecialiPerMalattie/Tubercolosi/SchedaSpecialeTubercolosi";
import Utils from "../../../../utils/Utils";
import SchedaSpecialeInfluenzaGrave from "./SchedeSpecialiPerMalattie/InfluenzaGrave/SchedaSpecialeInfluenzaGrave";
import SchedaSpecialeMalaria from "./SchedeSpecialiPerMalattie/Malaria/SchedaSpecialeMalaria";
import SchedaSpecialeMIB from "./SchedeSpecialiPerMalattie/MIB/SchedaSpecialeMIB";
import SchedaSpecialeEpatite from "./SchedeSpecialiPerMalattie/Epatite/SchedaSpecialeEpatite";
import SchedaSpecialeGenerica from "./SchedeSpecialiPerMalattie/SchedaSpecialeGenerica";
import SegnalazioniService from "../../../../services/SegnalazioniServices";
import history from "../../../../utils/History";
import {states} from "../../States/States";
import SchedaSpecialeMorbilloRosolia from "./SchedeSpecialiPerMalattie/MorbilloRosolia/SchedaSpecialeMorbilloRosolia";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../utils/OggettiUtili.json";
import {labelConfig} from "../../../../config/labelConfig";
import SessioneUtente from "../../../../sessionManager/SessioneUtente";
import ButtonRow from "../../../../components/ButtonRow/ButtonRow";
import toasterConfig from "../../../../config/toasterConfig";
import Modale from "../../../../components/modale/Modale";
import $ from "jquery";
import Ruoli from "../../../../utils/Ruoli.json";
import styles from "../Esito/Esito.module.css";
import Input from "../../../../components/textbox/Input";
import TableAllegati from "../../../../components/tableAllegati/TableAllegati";
import moment from "moment";
import globals from "../../../../config/appconfig";
import SchedaSpecialeEpatiteE from "./SchedeSpecialiPerMalattie/Epatite E/SchedaSpecialeEpatiteE";

class SchedaSpeciale extends Component {

    state = {
        sezione: null,
        corretto: false,
        schedaSpeciale: {},
        infoSchedaSpeciale: {},
        infoMalattia: "",
        validate: "",
        segnalazioneCopia: {},
        path: "",
        confermaScheda: true,
        confermaSchedaUtenteLab: null,
        saveMibSisp: true,
        saveMibLab: true,
        toasterMIB: "",
        malattiePerCodice: JSON.parse(sessionStorage.getItem("malattiePerCodice")),
        mibPerCodice: JSON.parse(sessionStorage.getItem("malattieUtenteLaboratorioPerCodice")),
        confermaStep: this.props.segnalazioneCopia && this.props.segnalazioneCopia.stepConfermati && this.props.segnalazioneCopia.stepConfermati.schedaSpecialeConfermata ? this.props.segnalazioneCopia.stepConfermati.schedaSpecialeConfermata : false,
        correttoTbc: false,

        filesCaricati: [],
        filesDaCaricare: []
    };


    constructor(props) {
        super(props);
        this.renderSwitch = this.renderSwitch.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.setSchedaSpecialeECorretto = this.setSchedaSpecialeECorretto.bind(this);
        this.validate = this.validate.bind(this);
        this.callToPutSegnalazione = this.callToPutSegnalazione.bind(this);
        this.callToConfermaDati = this.callToConfermaDati.bind(this);
        this._back = this._back.bind(this);
        this.setStateGenerico = this.setStateGenerico.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.callToCaricaPdf = this.callToCaricaPdf.bind(this);
        this.uploadAllegati = this.uploadAllegati.bind(this);
        this.updateFiles = this.updateFiles.bind(this);
        this.setStatePadre = this.setStatePadre.bind(this)
        this.obbligatorietaToaster = this.obbligatorietaToaster.bind(this)
    }


    onSubmit(e) {
        e.preventDefault()
    }


    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this)
        this.renderSwitch(this.props.datiPaziente.malattia)

        let state = {}

        if (this.props.infoMalattia) {
            state["infoSchedaSpeciale"] = this.props.infoMalattia
        }

        this.callToGetAllegati(state);
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
        this.props.navLabel("")
    }


    _back() {
        let path = "/ricercaSegnalazioni";
        history.push({pathname: path});
    }

    onClickFocolaio() {
        let path = "/InformazioniFocolaio";
        const ulssLenght = this.props.segnalazioneCopia.ulssSegnalazione.length
        const idLenght = String(this.props.segnalazioneCopia.idSegnalazione).length
        const zeroNeeded = 15 - ulssLenght - idLenght;
        const paddedIdSegnalazione = String(this.props.segnalazioneCopia.idSegnalazione).padStart(idLenght + zeroNeeded, '0')
        history.push({
            pathname: path,
            malattia: this.props.segnalazioneCopia.malattia,
            idSegnalazioneMonckey: this.props.segnalazioneCopia.ulssSegnalazione + paddedIdSegnalazione
        });
    }

    nextStep(path, segnalazioneSalvata, segnalazioneCopia) {
        history.push({
            pathname: path,
            state: {
                currentState:
                    segnalazioneSalvata.schedaSpeciale && segnalazioneSalvata.schedaSpeciale.caratteristicheDellaMalattia &&
                    segnalazioneSalvata.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
                    segnalazioneSalvata.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true" ? states.SCHEDA_SPECIALE_ESITO_TBC : states.HOME,
                segnalazione: segnalazioneSalvata,
                segnalazioneCopia: segnalazioneCopia,
                datiCompletiECorretti: Utils.getCompletezzaStep(segnalazioneSalvata)
            }
        });
    }


    aggiungiToaster(type, text, textList) {
        ToasterSingleton.instance().aggiuntaToaster(
            {
                type: type,
                text: text,
                timestamp: Date.now(),
                textList: textList
            });
    }


    setSchedaSpecialeECorretto(schedaSpeciale, validate, corretto, confermaScheda, toasterMIB) {
        this.controllaDati()
        let schedaDaSalvare = Utils.removeEmptyValueFromObject(schedaSpeciale)
        this.setState({
            schedaSpeciale: schedaDaSalvare,
            corretto: corretto,
            validate: validate,
            confermaScheda: confermaScheda || confermaScheda === false ? confermaScheda : null,
            toasterMIB: toasterMIB ? toasterMIB : ""
        })
    }


    async validate(clickSalvaOConferma) {
        if (this.state.validate) {
            return this.aggiungiToaster(toasterConfig.types.confirm, this.state.validate)
        }

        let jsonInsert = JSON.parse(JSON.stringify(this.props.segnalazione))

        if (this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale == 6) {
            var obj = Object.assign({}, jsonInsert["schedaSpeciale"], this.state.schedaSpeciale);  // salva sia i dati della sezione sisp/laboratorio già presenti in "jsonInsert["schedaSpeciale"]" che i dati della sezione compilata e salvata sisp/laboratorio di MIB
            jsonInsert["schedaSpeciale"] = obj
        } else {
            jsonInsert["schedaSpeciale"] = this.state.schedaSpeciale
        }


        if (SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Laboratorio.descrizione) {

            jsonInsert["schedaSpeciale"].diagnosiMIB = {};

            if (this.props.segnalazione && this.props.segnalazione.schedaSpeciale
                && this.props.segnalazione.schedaSpeciale.diagnosiMIB) {
                jsonInsert["schedaSpeciale"].diagnosiMIB = this.props.segnalazione.schedaSpeciale.diagnosiMIB
            }

        }

        jsonInsert["schedaSpeciale"].confermaScheda = this.state.confermaScheda
        if (this.state.confermaSchedaUtenteLab != null) jsonInsert["schedaSpeciale"].confermaSchedaUtenteLabMIB = clickSalvaOConferma === 1 && this.state.confermaSchedaUtenteLab !== null ? false : this.state.confermaSchedaUtenteLab

        jsonInsert["files"] = await Utils.getFiles(this.state.filesCaricati, this.state.filesDaCaricare);

        if (clickSalvaOConferma === 1) {
            this.callToPutSegnalazione(Utils.removeEmptyValueFromObject(jsonInsert));
        } else {
            this.callToConfermaDati(Utils.removeEmptyValueFromObject(jsonInsert));
        }
    }

    callToPutSegnalazione(jsonInsert) {
        SegnalazioniService.putModificaSegnalazione(jsonInsert, this.props.segnalazione.idSegnalazione, this.props.updateWizardState,
            this.props.segnalazione, this.props.showSpinner, this.updateFiles)
    }


    callToConfermaDati(jsonInsert) {
        let jsonSchedaSpeciale = {schedaSpeciale: jsonInsert.schedaSpeciale};
        jsonSchedaSpeciale["files"] = jsonInsert.files
        this.props.showSpinner(true);
        SegnalazioniService.postConfermaSchedaSpeciale(this.props.segnalazione.idSegnalazione, Utils.removeEmptyValueFromObject(jsonSchedaSpeciale))
            .then((data) => {
                this.props.showSpinner(false);
                if (data && data.status === 200) {
                    ToasterSingleton.instance().pulisci()
                    let segnalazioneSalvata = this.props.segnalazione;
                    segnalazioneSalvata["schedaSpeciale"] = this.state.schedaSpeciale
                    segnalazioneSalvata["stepConfermati"] = data.data.stepConfermati;
                    let path = segnalazioneSalvata.schedaSpeciale && segnalazioneSalvata.schedaSpeciale.caratteristicheDellaMalattia &&
                    segnalazioneSalvata.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
                    segnalazioneSalvata.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true" ? "/wizardSegnalazione" : "/ricercaSegnalazioni";
                    let state = this.state
                    state.segnalazioneCopia = segnalazioneSalvata
                    state.path = path
                    if (segnalazioneSalvata.malattia !== "0362" && SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione) {
                        state.mailInviataCorrettamente = false
                        this._back()
                    } else if (segnalazioneSalvata.malattia === "0362" && SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione) {
                        state.mailInviataCorrettamente = data.data.mailInviataCorrettamente
                        $('#modalButton_confermaInvioMail').trigger('click');
                    } else if (SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Laboratorio.descrizione) {
                        if (data.data.invioMail === false) {
                            this.nextStep(path, segnalazioneSalvata, this.props.segnalazioneCopia)
                        } else {
                            state.mailInviataCorrettamente = data.data.mailInviataCorrettamente
                            $('#modalButton_confermaInvioMail').trigger('click');
                        }
                    }
                    this.setState({state: state})
                    console.log("Chiamata al BE senza errori");
                    console.log("data: " + data.data);
                }
            })
            .catch((reason) => {
                this.props.showSpinner(false);
            })
    }


    callToCaricaPdf(data) {
        let segnalazioneSalvata = this.props.segnalazione;
        segnalazioneSalvata["pdfAssociato"] = data.data.pdfAssociato;
        segnalazioneSalvata["pdfInviato"] = data.data.pdfInviato;
        segnalazioneSalvata["idPdf"] = data.data.idPdf;
        let state = this.state
        state.segnalazioneCopia = segnalazioneSalvata
        this.props.updateWizardState({
            segnalazione: segnalazioneSalvata,
            segnalazioneCopia: segnalazioneSalvata
        });
        this.setState({state: state})
    }


    setStateGenerico(object) {
        this.setState(object)
    }


    async uploadAllegati(event) {
        this.props.showSpinner(true);
        let dimensioneMassimaFile = parseInt(globals["dimesione-massima-file"])
        let files = event.target.files;
        let pesoTotale = 0
        for (let key in files) {
            if (key !== "item" && key !== "length") {
                pesoTotale = pesoTotale + files[key].size
            }
        }
        if (files && files.length) {
            let oldFiles = this.state.filesDaCaricare;

            if (files.length + oldFiles.length > 5) {
                this.props.showSpinner(false);
                this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_LIMIT_CARICAMENTOFILE"]);
            } else if (pesoTotale > dimensioneMassimaFile) {
                this.props.showSpinner(false);
                this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_LIMIT_DIMENSIONEFILE"]);
            } else {
                let arrayFiles = Array.from(files);

                let result = arrayFiles.filter(file => {
                    return file.type !== "application/pdf";
                });

                if (result.length) {
                    this.props.showSpinner(false);
                    this.aggiungiToaster(toasterConfig.types.critical, ["Messages.MSG_ERROR_CARICAMENTOFILE"]);
                } else {

                    for (const file of arrayFiles) {
                        file.nome = file.name;
                        file.stato = "inserimento";
                        file.checked = true;
                        file.data = moment(new Date()).format('DD/MM/YYYY').toLocaleString();
                    }

                    if (oldFiles.length) {

                        for (const file of arrayFiles) {
                            oldFiles.push(file);
                        }

                        await this.setState({filesDaCaricare: oldFiles});
                        localStorage.setItem("scroll", "false");
                        this.renderSwitch(this.props.datiPaziente.malattia);
                    } else {
                        await this.setState({filesDaCaricare: arrayFiles});
                        localStorage.setItem("scroll", "false");
                        this.renderSwitch(this.props.datiPaziente.malattia);
                    }

                    this.props.showSpinner(false);
                }
            }
        } else this.props.showSpinner(false);

    }

    callToGetAllegati(state) {
        if (this.props.segnalazioneCopia.idSegnalazione && this.props.segnalazioneCopia.idPdf
            && Array.isArray(this.props.segnalazioneCopia.idPdf)) {
            SegnalazioniService.getAllegati(this.props.segnalazioneCopia.idSegnalazione).then(res => {
                state.filesCaricati = res.data;
                state.filesCaricati.forEach(file => {
                    file.checked = true
                });
                this.setState(state);
                this.renderSwitch(this.props.datiPaziente.malattia)
            }).catch(error => {
                console.log(error);
            });
        } else {
            this.setState(state);
        }
    }

    updateFiles(files) {
        if (files && files.length) {
            files.forEach(element => element.checked = true);
            this.setState({filesDaCaricare: [], filesCaricati: files});
        } else {
            this.setState({filesDaCaricare: [], filesCaricati: []});
        }
    }


    renderSwitch() {

        let sezione = null;


        if (this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale) {

            let label = "";
            if (this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale) {
                if (this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale == 5 &&
                    this.props.segnalazioneCopia.malattia === "056") {
                    label = labelConfig.wizardSegnalazione[labelConfig.wizardSegnalazione.length - 1]
                }

                let object = {
                    label: label ? label : labelConfig.wizardSegnalazione[this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale],
                    setStatePadre: this.setStateGenerico
                }
                this.props.navLabel({navLabel: object})

                switch (this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale) {
                    case 1: {
                        sezione =
                            <SchedaSpecialeMalaria
                                datiPaziente={this.props.datiPaziente}
                                segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                                setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}/>
                        break
                    }
                    case 2: {
                        sezione = <SchedaSpecialeInfluenzaGrave
                            datiPaziente={this.props.datiPaziente}
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                            setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}/>
                        break
                    }
                    case 3: {
                        if (this.props.segnalazioneCopia.malattia==="07053"){
                            sezione=<SchedaSpecialeEpatiteE
                                datiPaziente={this.props.datiPaziente}
                                segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                                setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}/>;
                        }
                        else {
                            sezione = <SchedaSpecialeEpatite
                                datiPaziente={this.props.datiPaziente}
                                segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                                setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}/>;
                        }
                        break
                    }
                    case 4: {
                        sezione = <SchedaSpecialeTubercolosi
                            datiPaziente={this.props.datiPaziente}
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                            setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}/>
                        break
                    }
                    case 5: {
                        sezione = <SchedaSpecialeMorbilloRosolia
                            datiPaziente={this.props.datiPaziente}
                            setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>
                        break
                    }
                    case 6: {
                        sezione = <SchedaSpecialeMIB
                            datiPaziente={this.props.datiPaziente}
                            malattia={this.props.malattia ? this.props.malattia : ""}
                            setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                            setConfermaSchedaLab={this.setStateGenerico}
                            caricaPdf={this.uploadAllegati}
                        />
                        break
                    }
                    case 7: {
                        let object = {
                            label: this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].descrizione === "LISTERIOSI" || this.state.malattiePerCodice[this.props.segnalazioneCopia.malattia].descrizione === "TETANO" ? labelConfig.wizardSegnalazione[8] : labelConfig.wizardSegnalazione[7],
                            setStatePadre: this.setStateGenerico
                        }
                        this.props.navLabel({navLabel: object})
                        sezione = <SchedaSpecialeGenerica
                            segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                            setSchedaSpecialeECorretto={this.setSchedaSpecialeECorretto}
                            caricaPdf={this.callToCaricaPdf}
                            showSpinner={this.props.showSpinner}
                        />
                    }

                }
            }
        }

        return this.setState({sezione: sezione});

    }


    controllaDati() {
        if (this.state.schedaSpeciale.caratteristicheDellaMalattia &&
            this.state.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
            this.state.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true" &&
            this.state.confermaStep) {

            if (Utils.object_equals(this.props.segnalazioneCopia.schedaSpeciale, this.state.schedaSpeciale)) {
                this.setState({correttoTbc: true})
            } else this.setState({correttoTbc: false})
        }

    }

    setStatePadre(state) {
        this.setState(state)
    }

    obbligatorietaToaster(tipo){
        let textList = this.state.corretto
        if(textList && textList.length > 0 && tipo === "1") return this.aggiungiToaster(toasterConfig.types.confirm, textList, true)
        else if(textList && textList.length > 0 && tipo === "2" && !(SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Laboratorio.descrizione && this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale == 6) &&
            !(SessioneUtente.getInstance().ruoliUtente == Ruoli.Operatore_Laboratorio.descrizione && this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale == 6) &&
            this.props.segnalazioneCopia.stepConfermati && this.props.segnalazioneCopia.stepConfermati.schedaSpecialeConfermata){
            return this.aggiungiToaster(toasterConfig.types.confirm, textList, true)
        }
        else{
            let path = this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia &&
            this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
            this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true" ? "/wizardSegnalazione" : "/ricercaSegnalazioni";

            if(tipo === "1"){
                if(this.props.segnalazioneCopia && (this.props.segnalazione && this.props.segnalazione.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)){
                    this.nextStep(path, this.props.segnalazioneCopia, this.props.segnalazioneCopia)
                }
                else{
                    this.validate(0)
                }
            }
            else if(tipo === "2") this.validate(1)
        }
    }

    render() {
        const {t} = this.props;
        let path = this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia &&
        this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
        this.props.segnalazioneCopia.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true" ? "/wizardSegnalazione" : "/ricercaSegnalazioni";

        const buttonDiv = (


            <ButtonRow
                segnalazioneC2={this.props.segnalazioneCopia.malattia === "0578" && !this.props.segnalazioneCopia.focolai && this.props.segnalazioneCopia.numeroContatti}
                migrazione={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) ? this.props.segnalazioneCopia.migrazione : false}
                onClickConfermaEProsegui={() => this.obbligatorietaToaster("1")}
                onClickFocolaio={() => this.onClickFocolaio()}
                isArchiviato={this.props.segnalazioneCopia && (this.props.segnalazione && this.props.segnalazione.migrazione) || this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice}
                modalTextConferma={this.state.correttoTbc ? t("Buttons.confermaModificaTbc") :
                    this.state.toasterMIB ? "Scheda di diagnosi di laboratorio completata. Confermare?" :
                        "Si vuole procedere con la chiusura della scheda di segnalazione speciale. Confermare?"}
                onClickSalva={() => this.obbligatorietaToaster("2")}
                //props allegati per il pulsante allegati che c'è in MIB in posizione diversa rispetto alle altre schede speciali
                allegati={this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale !== 7}
                onClickAllegati={this.uploadAllegati}
                nextStep={!!(this.state.schedaSpeciale.caratteristicheDellaMalattia &&
                    this.state.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
                    this.state.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true")}
                back={this._back}
                disabledCaricaAllegati={this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                noSalva={!(this.props.infoMalattia && this.props.infoMalattia.schedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale)}
            />
        )

        const modaleConfermaInvioMail = (
            <div>
                <Modale classes="btnWhite"
                        soloModale={true}
                        buttonMail={true}
                        id={"confermaInvioMail"}
                        name={"Conferma Invio Mail"}
                        typeModal="modalConsenso"
                        modalText={this.state.mailInviataCorrettamente ? "L’inserimento della segnalazione è stato correttamente notificato via e-mail alla Regione" :
                            "Invio e-mail non riuscito. Non è stato possibile notificare l’avvenuto inserimento"}
                        text={t("Buttons.conferma")}
                        title={t("Buttons.notificaMail")}
                        textButtonOk={"OK"}
                        style={{height: "3rem", marginTop: "1rem"}}
                        confirmFun={() => this.state.schedaSpeciale.caratteristicheDellaMalattia &&
                        this.state.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron &&
                        this.state.schedaSpeciale.caratteristicheDellaMalattia.polTrachBron === "true" ?
                            $('#modalButton_confermaStep7').trigger('click') : this.nextStep(this.state.path, this.state.segnalazioneCopia, this.state.segnalazioneCopia, this.state.datiPaziente)}
                />
            </div>
        )

        const modaleConfermaStep7 = (
            <div>
                <Modale classes="btnWhite"
                        soloModale={true}
                        id={"confermaStep7"}
                        name={"Conferma Step 7"}
                        typeModal="modalConsenso"
                        title={"Conferma e prosegui"}
                        modalText={t("Buttons.confermaModificaTbc")}
                        onClickKo={this._back}
                        style={{height: "3rem", marginTop: "1rem"}}
                        confirmFun={() => this.nextStep(this.state.path, this.state.segnalazioneCopia, this.state.segnalazioneCopia, this.state.datiPaziente)}
                />
            </div>
        )
        const secondSection = (
            <div>
                <div className={styles.margin}>
                    <h6>{t("Esito.migrazione")}</h6>
                    <hr className={styles.hr}></hr>
                </div>

                <div className={styles.margin}>
                    <div className="col-lg-8">
                        <Input
                            style={{height: "400px"}}
                            type={"textarea"}
                            id={"noteMigrazione"}
                            value={this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.altreInformazioniSchedaSpeciale ? JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.altreInformazioniSchedaSpeciale, undefined, 2) : ""}
                        >
                        </Input>
                    </div>
                </div>
            </div>
        );

        return (<div>
                {ToasterSingleton.instance().renderToaster()}
                <form onSubmit={this.onSubmit}>
                    <fieldset
                        disabled={this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale !== 7 && ((this.props.segnalazione && this.props.segnalazione.migrazione) || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice))}>
                        {this.state.sezione}
                    </fieldset>
                    {this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione ? secondSection : null}
                    {SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione ||
                    (this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale && this.props.infoMalattia.schedaSpeciale.idSchedaSpeciale === 7)
                        ? null
                        : <TableAllegati
                            filesCaricati={this.state.filesCaricati}
                            filesDaCaricare={this.state.filesDaCaricare}
                            segnalazioneCopia={this.props.segnalazioneCopia}
                            showSpinner={this.props.showSpinner}
                            setStatePadre={this.setStatePadre}
                            disabledCheckBox={this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice}
                        />


                    }
                    {buttonDiv}
                    {modaleConfermaInvioMail}
                    {modaleConfermaStep7}
                </form>
            </div>
        )
    }


}

export default withTranslation('common')(SchedaSpeciale)


